import type { ReactElement } from "react";
import { memo } from "react";

import {
    type TabContentComponentProps,
    TabWithCounter,
} from "app/pages/sales-intelligence/common-components/tabbed-page-content";
import type { PageTabBase } from "app/pages/sales-intelligence/common-components/tabbed-page-content/types";
import { useContactSearchResult } from "app/pages/sales-intelligence/sub-modules/contacts-search/hooks/useContactSearchResult";
import { formatNumberWithLimit } from "app/pages/sales-intelligence/utils/numbers";

import type { ContactsTabId } from "../../types/page-tabs";

type Props = TabContentComponentProps<PageTabBase<ContactsTabId>>;

const ContactsTabContainer = ({ tab, isSelected }: Props): ReactElement => {
    const { data, isFetching } = useContactSearchResult(false);
    const totalCount = data?.totalCount ?? 0;

    return (
        <TabWithCounter
            isLoading={isFetching}
            isSelected={isSelected}
            total={totalCount}
            formatNumber={formatNumberWithLimit}
            iconNameActive={tab.iconNameActive}
            iconNameInactive={tab.iconNameInactive}
            title={tab.title}
            withIconFill
        />
    );
};

export default memo(ContactsTabContainer);
